/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Closing_Appstore_LabelInputs */

const en_closing_appstore_label = /** @type {(inputs: Closing_Appstore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download on the App Store`)
};

const de_closing_appstore_label = /** @type {(inputs: Closing_Appstore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im App Store laden`)
};

const zh_tw_closing_appstore_label = /** @type {(inputs: Closing_Appstore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store 下載連結`)
};

const zh_cn_closing_appstore_label = /** @type {(inputs: Closing_Appstore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store 下载链接`)
};

const es_closing_appstore_label = /** @type {(inputs: Closing_Appstore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar en App Store`)
};

const fr_closing_appstore_label = /** @type {(inputs: Closing_Appstore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger sur l'App Store`)
};

const it_closing_appstore_label = /** @type {(inputs: Closing_Appstore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica dall'App Store`)
};

const pt_br_closing_appstore_label = /** @type {(inputs: Closing_Appstore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixe na App Store`)
};

const ja_closing_appstore_label = /** @type {(inputs: Closing_Appstore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store でダウンロード`)
};

const ko_closing_appstore_label = /** @type {(inputs: Closing_Appstore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store 다운로드`)
};

const ru_closing_appstore_label = /** @type {(inputs: Closing_Appstore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скачать в App Store`)
};

const th_closing_appstore_label = /** @type {(inputs: Closing_Appstore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดาวน์โหลดบน App Store`)
};

const tr_closing_appstore_label = /** @type {(inputs: Closing_Appstore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store'dan indir`)
};

const ar_closing_appstore_label = /** @type {(inputs: Closing_Appstore_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حمّله من App Store`)
};

/**
* | output |
* | --- |
* | "Download on the App Store" |
*
* @param {Closing_Appstore_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }} options
* @returns {LocalizedString}
*/
export const closing_appstore_label = /** @type {((inputs?: Closing_Appstore_LabelInputs, options?: { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Closing_Appstore_LabelInputs, { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_closing_appstore_label(inputs)
	if (locale === "de") return de_closing_appstore_label(inputs)
	if (locale === "zh_tw") return zh_tw_closing_appstore_label(inputs)
	if (locale === "zh_cn") return zh_cn_closing_appstore_label(inputs)
	if (locale === "es") return es_closing_appstore_label(inputs)
	if (locale === "fr") return fr_closing_appstore_label(inputs)
	if (locale === "it") return it_closing_appstore_label(inputs)
	if (locale === "pt_br") return pt_br_closing_appstore_label(inputs)
	if (locale === "ja") return ja_closing_appstore_label(inputs)
	if (locale === "ko") return ko_closing_appstore_label(inputs)
	if (locale === "ru") return ru_closing_appstore_label(inputs)
	if (locale === "th") return th_closing_appstore_label(inputs)
	if (locale === "tr") return tr_closing_appstore_label(inputs)
	return ar_closing_appstore_label(inputs)
});